export enum Service {
  MOGA_BE = "moga",
  ADMIN_BE = "admin",
}
export enum ServicePort {
  MOGA_BE = 7070,
  ADMIN_BE = 7071,
}
